/* eslint-disable react/no-unknown-property */
import React from 'react';
import { Button } from 'react-bootstrap';

export const AMAZONGO_LOCATION_NAMES = {
  'CHI_Wholesale (directcms) - 0062M00000l5vHiQAI_IOR1': {
    SFLocationName: 'AMAZONGO_IOR1_WCHICAGO',
    ShippingLocationName: 'IL_AMAZON_GO_IOR1__5370_S_CICERO_AVE',
  },
  'CHI_Wholesale (directcms) - 0062M00000l5vHiQAI_ICH2': {
    SFLocationName: 'AMAZONGO_ICH2_MERCHANDISEMART',
    ShippingLocationName: 'IL_AMAZON_GO_ICH2__5370_S_CICERO_AVE',
  },
  'CHI_Wholesale (directcms) - 0062M00000l5vHiQAI_ICH3': {
    SFLocationName: 'AMAZONGO_ICH3_MADISON',
    ShippingLocationName: 'IL_AMAZON_GO_ICH3__5370_S_CICERO_AVE',
  },
  'CHI_Wholesale (directcms) - 0062M00000l5vHiQAI_ICH4': {
    SFLocationName: 'AMAZONGO_ICH4_MONROE',
    ShippingLocationName: 'IL_AMAZON_GO_ICH4__5370_S_CICERO_AVE',
  },
  'CHI_Wholesale (directcms) - 0062M00000l5vHiQAI_ICH6': {
    SFLocationName: 'AMAZONGO_ICH6_ONETWOPRU',
    ShippingLocationName: 'IL_AMAZON_GO_ICH4__5370_S_CICERO_AVE',
  },
};

export const OVERRIDE_ELIGIBLE_ROUTING_TAGS = ['Group Drop', 'Pickup', '3PL'];

export const DROP_REASONS = {
  Complete: [
    {
      text: 'Drivers App Tech Issue',
      value: 'DRIVERS_APP_TECH_ISSUE',
    },
    {
      text: 'Group Drop',
      value: 'GROUP_DROP',
    },
    {
      text: 'Warehouse Pickup',
      value: 'WAREHOUSE_PICKUP',
    },
    {
      text: 'Third-Party Drop',
      value: 'THIRD_PARTY_DROP',
    },
  ],
  'Not Delivering': [
    {
      text: 'No CMS Pick Ticket',
      value: 'NO_CMS_PICK_TICKET',
    },
    {
      text: 'Missing Totes',
      value: 'MISSING_TOTES',
    },
    {
      text: 'Line Haul Delay',
      value: 'LINE_HAUL_DELAY',
    },
    {
      text: 'Client Rejected Order',
      value: 'CLIENT_REJECTED_ORDER',
    },
    {
      text: 'Order was Cancelled but food was made',
      value: 'ORDER_CANCELLED_BUT_FOOD_MADE',
    },
    {
      text: 'Fridge Maintenance Issue',
      value: 'FRIDGE_MAINTENANCE_ISSUE',
    },
    {
      text: 'FF Delivery Issue',
      value: 'FF_DELIVERY_ISSUE',
    },
  ],
};

const checkStatusForReasons = (rowData) => {
  if (rowData.dropStatus !== 'Pending') {
    return rowData.dropStatus;
  }
  return rowData.dropStatusToOverride === 'Pending'
    ? 'Complete'
    : rowData.dropStatusToOverride;
};

export const getDropOffSummaryColumns = (onClickUndo, formatTimestamp) => [
  {
    key: 'checkbox',
    dataKey: 'checkbox',
    width: 50,
    cellRenderer: ({ rowData }) => (
      <input
        type="checkbox"
        value={rowData.locationId}
        checked={rowData.checked}
        className="checkbox"
        onChange={() => undefined} // avoid errors about controlled input without onChange
        disabled={
          rowData.dropStatus !== 'Pending' || !rowData.isOverrideEligible
        }
        title={
          !rowData.isOverrideEligible
            ? 'Override unavailable: route type is not eligible (Group Drop, Pickup, or 3PL only)'
            : undefined
        }
        data-packingslipid={rowData.extendedUniqueId}
        data-locationid={rowData.locationId}
      />
    ),
  },
  {
    title: 'Location ID',
    key: 'displayLocationId',
    dataKey: 'displayLocationId',
    width: 500,
    sortable: true,
  },
  {
    title: 'Route ID',
    key: 'route',
    dataKey: 'route',
    width: 150,
    sortable: true,
  },
  {
    title: 'Packing Slip ID',
    key: 'uniqueId',
    dataKey: 'uniqueId',
    width: 150,
    sortable: true,
  },
  {
    title: 'Pick Date',
    key: 'createDate',
    dataKey: 'createDate',
    width: 100,
  },
  {
    title: 'Drop Status',
    key: 'dropStatus',
    dataKey: 'dropStatus',
    width: 250,
    minWidth: 250,
    sortable: true,
    cellRenderer: ({ rowData }) => {
      // Show Undo button for Complete or Not Delivering status
      if (
        rowData.dropStatus === 'Complete' ||
        rowData.dropStatus === 'Not Delivering'
      ) {
        return (
          <div className="complete-status-container">
            <select
              className="statusDropdown"
              value={rowData.dropStatus}
              disabled
              onChange={() => undefined}
            >
              <option value={rowData.dropStatus}>{rowData.dropStatus}</option>
            </select>
            <Button
              bsStyle="primary"
              bsSize="xsmall"
              className="undo-button"
              onClick={(e) => {
                e.stopPropagation();
                onClickUndo(rowData);
              }}
            >
              Undo
            </Button>
          </div>
        );
      }

      // For Pending status - show dropdown with optional timestamp
      const timestampText =
        rowData.wasCompleted && rowData.lastModified
          ? formatTimestamp(rowData.lastModified)
          : null;

      return (
        <div className="pending-status-container">
          <select
            className="statusDropdown"
            value={
              rowData.dropStatus !== 'Pending'
                ? rowData.dropStatus
                : rowData.dropStatusToOverride
            }
            disabled={
              rowData.dropStatus !== 'Pending' || !rowData.isOverrideEligible
            }
            title={
              !rowData.isOverrideEligible
                ? 'Override unavailable: route type is not eligible (Group Drop, Pickup, or 3PL only)'
                : undefined
            }
            data-packingslipid={rowData.extendedUniqueId}
            data-locationid={rowData.locationId}
            onChange={() => undefined}
          >
            <option value="Pending">Pending</option>
            {rowData.locationType !== 'FRIDGE' && (
              <option value="Complete">Complete</option>
            )}
            <option value="Not Delivering">Not Delivering</option>
          </select>
          {timestampText && (
            <div className="timestamp-text">
              Status reverted - {timestampText}
            </div>
          )}
        </div>
      );
    },
  },
  {
    key: 'reason',
    title: 'Reason',
    dataKey: 'reason',
    width: 250,
    cellRenderer: ({ rowData }) => {
      return (
        <select
          className={`statusReason ${
            rowData.dropStatusToOverride === 'Pending' &&
            rowData.statusReason === '' &&
            'hide'
          }`}
          value={rowData.statusReason}
          disabled={rowData.dropStatusToOverride === 'Pending'}
          data-packingslipid={rowData.extendedUniqueId}
          data-locationid={rowData.locationId}
          onChange={() => undefined} // avoid errors about controlled input without onChange
        >
          {DROP_REASONS[checkStatusForReasons(rowData)].map(
            ({ value, text }) => (
              <option value={value} key={value}>
                {text}
              </option>
            ),
          )}
        </select>
      );
    },
  },
  {
    title: 'Created By',
    key: 'userSubmitted',
    dataKey: 'userSubmitted',
    width: 250,
    cellRenderer: ({ rowData }) => (
      <div className="userSubmitted" title={rowData.userSubmitted}>
        {rowData.userSubmitted}
      </div>
    ),
  },
];

// Export backward compatible version (without undo functionality)
export const DROP_OFF_SUMMARY_COLUMNS = getDropOffSummaryColumns(
  () => {},
  () => null,
);
